import React from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import { transValueFormatGrowth, transValueFormat } from '../../_config/utils';

export default function CardShow(porps: any) {
  let { data } = porps;
  const dod = transValueFormatGrowth(data?.dod);
  const dodCal = transValueFormat(data?.dod);
  const type = Number(dodCal) > 0 ? 'up' : Number(dodCal) < 0 ? 'down' : '';
  return (
    <CardSlotV2 iconList={[]} title={data.name} className="dbi-detail-card">
      <div className="dbi-detail-card-num">{data.value ? data.value : '-'}</div>
      {data.dod ? (
        <div
          className={
            type == 'up'
              ? 'dbi-detail-card-green'
              : type == 'down'
              ? 'dbi-detail-card-red'
              : 'dbi-detail-card-gray'
          }
        >
          {dod}
          {type ? (
            <SvgIcon
              type={type == 'up' ? 'green-up-new' : 'red-down-new'}
              className="dbi-detail-card-icon"
            />
          ) : (
            <span className="dbi-detail-card-nodata">-</span>
          )}
        </div>
      ) : (
        '-'
      )}
    </CardSlotV2>
  );
}
